import styled from 'styled-components';

const InputsContainer = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: nowrap;
`;

export default InputsContainer;
